export const SectionHeader = ({ sectionTitle, sectionIntro }) => {
  return (
    <div className="flex flex-col justify-center w-full gap-4 px-4 mx-auto mt-12">
      <h2 className="text-4xl font-semibold text-center md:text-5xl text-secondary">
        {sectionTitle}
      </h2>
      <div className="block h-1 mx-auto rounded-full w-44 bg-primary justify-items-center" />
      {sectionIntro && (
        <div
          className="text-lg text-center md:mx-20 lg:mx-48 xl:mx-80 2xl:mx-96 section-header-rich text-secondary"
          dangerouslySetInnerHTML={{ __html: sectionIntro }}
        />
      )}
    </div>
  )
}
